var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1675 33.4656C25.4251 38.0648 17.0197 37.7027 11.6967 32.3797C5.98523 26.6683 5.98523 17.4083 11.6967 11.6969C17.4081 5.98548 26.6682 5.98548 32.3795 11.6969C37.7026 17.0199 38.0646 25.4253 33.4654 31.1676L44.6359 42.3381C45.2705 42.9727 45.2705 44.0017 44.6359 44.6363C44.0015 45.2709 42.9725 45.2709 42.3379 44.6363L31.1675 33.4656ZM13.9947 30.0817C9.55254 25.6394 9.55254 18.4372 13.9947 13.995C18.437 9.55278 25.6392 9.55278 30.0815 13.995C34.5204 18.434 34.5236 25.6288 30.0913 30.072C30.0878 30.0752 30.0846 30.0782 30.0813 30.0817C30.0781 30.085 30.0748 30.0882 30.0716 30.0915C25.6286 34.5238 18.4337 34.5206 13.9947 30.0817Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarch);
export default __webpack_public_path__ + "static/media/earch.660b9470bfa8d1e0426e85ab304d1c64.svg";
export { ForwardRef as ReactComponent };